import React, { useEffect, useState } from 'react';
import { resolveApiUrl } from '../api/api';
import { menuHeaders, publicMenuApi } from '../api/publicMenu';
import { Link, useSearchParams } from 'react-router-dom';
import { SaleCatalogItem } from '../types';

const MenuPage: React.FC = () => {
  const [items, setItems] = useState<SaleCatalogItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [params] = useSearchParams();
  const access = params.get('access') || '';

  useEffect(() => {
    let active = true;
    setItems([]);
    setError('');
    setLoading(true);
    if (!access) {
      setError('Відкрийте чинне посилання меню або QR-код ресторану. Публікацію має підтвердити адміністратор.');
      setLoading(false);
      return;
    }
    publicMenuApi.get<SaleCatalogItem[]>('/sale-catalog', { headers: menuHeaders(access) })
      .then(({ data }) => {
        if (active) setItems(data);
      })
      .catch(() => {
        if (active) setError('Публікація недоступна, відкликана або прострочена. Відкрийте нове посилання ресторану.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [access]);

  const categories = Array.from(new Set(items.map((item) => item.category)));

  return (
    <div className="page-shell page-shell--wide">
      <h2 style={{ color: 'var(--crm-text)', borderBottom: '2px solid var(--crm-accent)', paddingBottom: '8px' }}>
        Меню
      </h2>
      {!loading && !error && items.some(item => item.itemType === 'menu-item') &&
        <Link to={`/order?access=${encodeURIComponent(access)}`}>Замовити з меню ресторану</Link>}
      {loading ? (
        <p>Завантаження...</p>
      ) : error ? (
        <p role="alert">{error}</p>
      ) : items.length === 0 ? (
        <p style={{ color: 'var(--crm-text-muted)' }}>Зараз немає затверджених позицій для продажу.</p>
      ) : (
        categories.map((category) => (
          <div key={category} style={{ marginTop: '24px' }}>
            <h3 style={{
              color: 'var(--crm-text)',
              background: 'var(--crm-surface-alt)',
              border: '1px solid var(--crm-border)',
              padding: '8px 16px',
              borderRadius: 'var(--crm-radius-sm)',
            }}>
              {category}
            </h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
              gap: '16px',
            }}>
              {items.filter((item) => item.category === category).map((item) => (
                <article key={`${item.itemType}-${item.id}`} style={{
                  background: 'var(--crm-surface)',
                  border: '1px solid var(--crm-border)',
                  borderRadius: 'var(--crm-radius-md)',
                  boxShadow: 'var(--crm-shadow-sm)',
                  overflow: 'hidden',
                }}>
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl.startsWith('/sale-catalog/')
                        ? resolveApiUrl(item.imageUrl)
                        : item.imageUrl}
                      alt=""
                      style={{ width: '100%', height: '140px', objectFit: 'cover' }}
                    />
                  )}
                  <div style={{ padding: '12px' }}>
                    <h4 style={{ margin: '0 0 6px', color: 'var(--crm-text)' }}>{item.name}</h4>
                    <p style={{ margin: '0 0 8px', color: 'var(--crm-text-muted)', fontSize: '13px' }}>{item.description}</p>
                    <p style={{ margin: 0, color: 'var(--crm-accent)', fontWeight: 'bold', fontSize: '16px' }}>
                      {item.price.toFixed(2)} ₴
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default MenuPage;
